import React, { useState } from "react";
import axios from "axios";
import { Modal, Button } from 'react-bootstrap';
import Swal from "sweetalert2";
import { pixelSuscribirKlaviyo } from '../../funcionesDatos/pixelFacebook';
import { gtagSuscribirKlaviyo } from '../../funcionesDatos/pixelGoogle';
import { ttqSuscribirKlaviyo } from '../../funcionesDatos/pixelTiktok';
import { eventoSuscribirKlaviyo } from '../../funcionesDatos/eventoPropio';

function SuscribirKlaviyo({ usuario, setUsuario }) {

    const [show, setShow] = useState(false);
    const [cargando, setCargando] = useState(false);

    async function handleSuscribir() {
        try {
            setCargando(true);
            const res = await axios.post("/suscribir-klaviyo", { username: usuario });

            if (res.data.ok) {
                pixelSuscribirKlaviyo({ origen: "cuenta" });
                gtagSuscribirKlaviyo({ origen: "cuenta" });
                ttqSuscribirKlaviyo({ origen: "cuenta" });
                eventoSuscribirKlaviyo({ origen: "cuenta" });
                if (typeof setUsuario === "function") {
                    setUsuario(prev => ({ ...prev, aceptaMarketing: true }));
                }
                setShow(false);
                Swal.fire({
                    icon: "success",
                    title: "¡Suscrito!",
                    text: "Recibirás novedades y promociones de Zervicy en tu correo.",
                    confirmButtonText: "Listo",
                    customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" }
                });
            } 
            else {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: res.data.mensaje || "No pudimos suscribirte. Intenta de nuevo.",
                    confirmButtonText: "Ok",
                    customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" }
                });
            }
        }
        catch (err) {
            console.error("Error al suscribirse:", err);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Hubo un problema al procesar tu solicitud.",
                confirmButtonText: "Ok",
                customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" }
            });
        }
        finally {
            setCargando(false);
            window.location.reload();
        }
    }

    return (
        <div>
            <Button variant="primary" onClick={() => setShow(true)}>
                <i className="bi bi-envelope-check me-2"></i>
                Suscribirme al correo
            </Button>

            <Modal show={show} onHide={() => setShow(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Suscríbete a Zervicy</Modal.Title>
                </Modal.Header>

                <Modal.Body className="text-center py-4">
                    <i className="bi bi-envelope-heart" style={{ fontSize: "48px", color: "var(--naranja-cta)" }} />
                    <h5 className="mt-3 mb-2">Recibe lo mejor de Zervicy</h5>
                    <p className="text-muted mb-0">
                        Te enviaremos novedades, promociones exclusivas y actualizaciones
                        de la plataforma directamente a tu correo.
                    </p>
                </Modal.Body>

                <Modal.Footer className="d-flex flex-column gap-2">
                    <Button
                        variant="primary"
                        className="w-100"
                        onClick={handleSuscribir}
                        disabled={cargando}
                    >
                        {cargando
                            ? <><span className="spinner-border spinner-border-sm me-2" />Suscribiendo...</>
                            : <><i className="bi bi-check-circle me-2" />Suscribirme</>
                        }
                    </Button>
                    <Button variant="secondary" className="w-100" onClick={() => setShow(false)}>
                        Cancelar
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default SuscribirKlaviyo;
